// services/PatternGenerationService.js
import WebSocketService from '@/services/WebsocketService'

class PatternGenerationService {
  static instance = null
  ws = null

  static getInstance () {
    if (!PatternGenerationService.instance) {
      PatternGenerationService.instance = new PatternGenerationService()
    }
    return PatternGenerationService.instance
  }

  connect (url, callbacks) {
    if (this.ws) {
      this.ws.close()
    }
    this.ws = new WebSocketService(url)
    this.ws.on('open', callbacks.onConnect)
    this.ws.on('close', callbacks.onDisconnect)
    this.ws.on('error', callbacks.onError)
    this.ws.on('message', callbacks.onMessage)
    this.ws.initialize()
  }

  sendMessage (payload) {
    if (!this.ws) {
      throw new Error('Pattern Generation Service not connected')
    }
    console.log('pgs.sendMessage: ', this.ws, JSON.stringify(payload))
    this.ws.send(payload)
  }

  disconnect () {
    if (this.ws) {
      this.ws.close()
      this.ws = null
    }
  }
}

export default PatternGenerationService
